import { isWithinInterval } from "date-fns";
import { LocationOn as LocationOnIcon } from "@mui/icons-material";

import React, { useCallback, useContext, useMemo, useState } from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import "../css/calendar.scss";
import { dateTimeFormatter } from "../helperFunctions/dateFormatters";
import Footer from "./Footer";
import IdentifierBar from "./IdentifierBar";

import CalendarCard from "./CalendarCard";
import { add, sub, subDays } from "date-fns";

import useCalendar from "../customHooks/useCalendar";
import { tooltips } from "../popData";
import FooterBtn from "./FooterBtn";
import { useHistory } from "react-router-dom";
import {
  TimesheetsContext,
  JobsheetsContext,
  QuotesContext,
} from "../providers";
import { filterSchedulerPrimaries } from "../helperFunctions/calendarFunctions";
import CalendarControls from "./CalendarControls";
import { useBatchPendingDraftsCheck } from "../customHooks";

const Calendar = () => {
  const history = useHistory();
  // Date which will be shown when navigating to Calendar

  let [showDate, setShowDate] = useState(
    (window?.sessionStorage?.getItem("calendar_date") &&
      new Date(window?.sessionStorage?.getItem("calendar_date"))) ||
      new Date()
  );

  const [daysOfWeek, startOfWeek, endOfWeek] = useCalendar(showDate);

  // Opportunistically resolve any pending Gmail drafts on the primaries visible in the
  // currently-viewed week, re-checking whenever the visible week changes.
  const primariesInView = (daysOfWeek || [])
    .flatMap((day) => day.data || [])
    .filter((entry) => !entry.timeBlock);
  useBatchPendingDraftsCheck(primariesInView, startOfWeek?.getTime(), primariesInView.length);

  // Weeked toggle
  let [hideWeekends] = useState(true);

  // function goBackOneWeek() {
  //   let backOneWeekDate = sub(showDate, { weeks: 1 });
  //   window.sessionStorage.setItem("calendar_date", backOneWeekDate);
  //   setShowDate(backOneWeekDate);
  // }

  // function goForwardOneWeek() {
  //   let forwardOneWeekDate = add(showDate, { weeks: 1 });
  //   window.sessionStorage.setItem("calendar_date", forwardOneWeekDate);
  //   setShowDate(forwardOneWeekDate);
  // }

  async function mapView() {
    let markedItems = [];
    let timesheets = [];
    // let sheetsForMap = booked.concat(potentials);
    // console.log("sheetsForMap", sheetsForMap);
    // return;
    history.push("/tom-tom-map", {
      sheets: [],
    });
  }

  return (
    <>
      <Footer title="Calendar" back={true}>
        <FooterBtn title={tooltips.mapView} cb={mapView} show={true}>
          <LocationOnIcon style={{ fontSize: 30 }} />
        </FooterBtn>
      </Footer>

      <IdentifierBar title="Calendar" back={true} />

      {/* <div style={{ height: "150px", overflow: "scroll" }}>
        {potentials.map((data) => {
          return (
            <div key={data.uid}>
              {data.authorisedBy} - {data.status}
            </div>
          );
        })}
      </div> */}

      <div className="calendar-view">
        {/* <h1>Calendar</h1> */}

        <div className="week-view">
          <CalendarControls
            showDate={showDate}
            setShowDate={setShowDate}
            isCalendar={true}
          />
          {/* <div className="calendar-toolbar">
            <div className="startAndEndOfWeek">
              <button onClick={goBackOneWeek}>
                <ArrowBackIcon />
              </button>
              <div>
                <p>{dateTimeFormatter(startOfWeek, "d_short")}</p>
                <p className="seperator"> -- </p>
                <p>{dateTimeFormatter(subDays(endOfWeek, 2), "d_short")}</p>
              </div>
              <button onClick={goForwardOneWeek}>
                <ArrowForwardIcon />
              </button>
            </div>

            {!todayInCurrentWeek && (
              <button
                className="today-btn"
                onClick={() => {
                  window.sessionStorage.setItem("calendar_date", new Date());
                  setShowDate(new Date());
                }}
              >
                Today
              </button>
            )} */}

          {/* <button
              className="show-weekends-btn"
              onClick={() => setHideWeekends((p) => !p)}
            >
              {hideWeekends ? "Show" : "Hide"} Wk/ends
            </button> */}
          {/* </div> */}

          <div className="calendar-days">
            {/* <div className="card-selected"></div> */}
            {daysOfWeek?.map(({ label, date, data }, i) => {
              if (hideWeekends) {
                if (i === 5 || i === 6) {
                  return null;
                }
              }

              let isSameDay = new Date().getDate() === date.getDate();
              let isSameMonth = new Date().getMonth() === date.getMonth();

              let isToday = isSameDay && isSameMonth;

              return (
                <div key={`${label}${i}`} className="day">
                  <p
                    style={{
                      background: isToday ? "var(--costLineRed)" : "lightgrey",
                    }}
                    className="day-header"
                  >
                    {label} {date.getDate()}
                  </p>

                  <div className="jobsForTheDay">
                    {data?.map((details, i) => {
                      if (details.timeBlock) {
                        return (
                          <div
                            // style={{ height: `${details.timeDifference}px` }}
                            key={i}
                            className="timeBlock"
                          >
                            <p>
                              {details.timeDifference}
                              &nbsp;<span>mins</span>
                            </p>
                          </div>
                        );
                      }

                      return (
                        <CalendarCard details={details} key={details.uid} />
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Calendar;
